<template>
  <section ref="maskSection" class="svg-mask-scroll-wrapper">
    <div class="svg-mask-container">
      <!-- 預載完成才顯示主內容 -->
      <template v-if="imagesLoaded">
        <!-- 底層原圖 -->
        <img
          :src="currentImage"
          class="full-bg"
          :class="{ 'fade-in': fadeIn }"
          alt="frame"
          draggable="false"
        />
        <!-- 黑色遮罩層（中間洞透明）-->
        <svg
          v-if="showMask"
          :width="windowWidth"
          :height="windowHeight"
          class="svg-viewport"
          :style="{ position: 'absolute', top: 0, left: 0, opacity: 1, pointerEvents: 'none', zIndex: 3 }"
        >
          <defs>
            <mask id="text-mask">
              <!-- 黑底 -->
              <rect :width="windowWidth" :height="windowHeight" fill="white"/>
              <!-- 洞：白色填充 -->
              <g v-if="!isPortraitMode" :transform="maskTransform">
                <!-- 橫式遮罩內容 -->
                <polygon fill="black" points="276.43 450.89 431.84 450.89 431.84 717.14 541.6 717.14 541.6 450.89 697 450.89 697 362.85 276.43 362.85 276.43 450.89"/>
                <polygon fill="black" points="1189.3 362.85 1189.3 717.13 1300.15 717.13 1300.15 579.12 1346.88 579.12 1502.29 717.13 1643.57 717.13 1444.69 540 1643.57 362.85 1502.29 362.85 1346.88 500.88 1300.15 500.88 1300.15 362.85 1189.3 362.85"/>
                <path fill="black" d="M730.7,606.28v10.87c0,55.42,44.56,99.98,99.98,99.98h222.78c55.42,0,99.98-44.56,99.98-99.98v.03s.01-13.04.01-13.04c0-55.42-44.56-99.98-99.98-99.98l-184.75-1.09c-15.22,0-27.17-13.05-27.17-28.26v-6.52c0-15.22,11.96-27.17,27.17-27.17h143.45c7.61,0,14.13,3.26,19.56,8.69,5.44,5.43,7.61,11.95,7.61,19.56v5.43h110.85v-10.87c0-55.42-44.56-99.98-99.98-99.98h-220.61c-54.33,0-98.89,44.55-98.89,98.89v13.04c0,55.42,44.55,99.98,98.89,99.98l184.75,2.17c7.61,0,14.13,3.26,19.56,8.69,5.43,5.43,7.6,11.95,8.69,19.56v5.43c0,7.61-2.18,14.13-7.61,19.56-5.43,5.44-11.95,7.61-19.56,7.61h-154.32c-15.22,0-27.17-11.96-27.17-27.17v-5.43h-103.24Z"/>
              </g>
              <g v-else :transform="maskTransform">
                <!-- 直式遮罩內容 -->
                <polygon fill="black" points="122.74 905.6 217.6 905.6 217.6 1068.13 284.6 1068.13 284.6 905.6 379.46 905.6 379.46 851.86 122.74 851.86 122.74 905.6"/>
                <polygon fill="black" points="679.97 851.86 679.97 1068.12 747.63 1068.12 747.63 983.88 776.16 983.88 871.02 1068.12 957.26 1068.12 835.86 960 957.26 851.86 871.02 851.86 776.16 936.12 747.63 936.12 747.63 851.86 679.97 851.86"/>
                <path fill="black" d="M400.03,1000.46v6.64c0,33.83,27.2,61.03,61.03,61.03h135.99c33.83,0,61.03-27.2,61.03-61.03v.02-7.96c0-33.83-27.19-61.03-61.02-61.03l-112.77-.67c-9.29,0-16.59-7.97-16.59-17.25v-3.98c0-9.29,7.3-16.59,16.59-16.59h87.56c4.65,0,8.63,1.99,11.94,5.3,3.32,3.31,4.65,7.29,4.65,11.94v3.31h67.66v-6.64c0-33.83-27.2-61.03-61.03-61.03h-134.66c-33.16,0-60.36,27.19-60.36,60.36v7.96c0,33.83,27.19,61.03,60.36,61.03l112.77,1.32c4.65,0,8.63,1.99,11.94,5.3s4.64,7.29,5.3,11.94v3.31c0,4.65-1.33,8.63-4.65,11.94-3.31,3.32-7.29,4.65-11.94,4.65h-94.2c-9.29,0-16.59-7.3-16.59-16.59v-3.31h-63.02Z"/>
              </g>
            </mask>
          </defs>
          <!-- 黑色覆蓋、透明洞展開（透明度可調整，通常用 0.82~0.9 最像「遮罩」感） -->
          <rect
            :width="windowWidth"
            :height="windowHeight"
            fill="#000"
            :mask="'url(#text-mask)'"
            opacity="1"
          />
        </svg>
        <img
          v-if="showMask && mouseIconVisible"
          src="@/assets/images/mouse.png"
          alt="Scroll Down"
          class="scroll-mouse-icon"
          draggable="false"
          :style="{ top: mouseIconTop + 'vh' }"
        />
        <!-- 手機/直式：逐段顯示 -->
        <h1 v-if="isPortraitMode && progress >= 0.3 && progress < 0.6" class="herophone-title">
          <span class="line-1 animate-line delay-1">
            <div v-html="$t('TskSelectNeedle.mask_phone_1-1')"></div>
          </span>
          <span class="gradient animate-line delay-2">
            <div v-html="$t('TskSelectNeedle.mask_phone_1-2')"></div>
          </span>
        </h1>
        <h1 v-if="isPortraitMode && progress >= 0.6" class="herophone-title">
          <span class="line-1 animate-line delay-1">
            <div v-html="$t('TskSelectNeedle.mask_phone_2-1')"></div>
          </span>
          <span class="gradient animate-line delay-2">
            <div v-html="$t('TskSelectNeedle.mask_phone_2-2')"></div>
          </span>
        </h1>

        <!-- 電腦/橫式：維持原本單段 -->
        <h1 v-if="!isPortraitMode && progress >= 0.3 && progress < 0.6" class="hero-title">
          <span class="hero-bg-glow"></span>
          <span class="line-1 animate-line delay-1">
            <div v-html="$t('TskSelectNeedle.mask1')"></div>
          </span>
        </h1>
        <h1 v-if="!isPortraitMode && progress >= 0.6" class="hero-title">
          <span class="hero-bg-glow"></span>
          <span class="line-1 animate-line delay-2">
            <div v-html="$t('TskSelectNeedle.mask2')"></div>
          </span>
        </h1>


      </template>
      <!-- loading 遮罩與進度條 -->
      <div v-if="!imagesLoaded" class="progress-mask">



        <div class="progress-svg-mask-wrap">
          <svg
            :width="windowWidth"
            :height="windowHeight"
            :viewBox="`0 0 ${windowWidth} ${windowHeight}`"
            class="progress-svg-mask"
          >
            <defs>
              <mask id="full-mask">
                <!-- 黑底 -->
                <rect :width="windowWidth" :height="windowHeight" fill="black"/>
                <!-- 遮罩內容：分橫式與直式 -->
                <g v-if="!isPortraitMode" :transform="loadingMaskTransform">
                  <!-- 橫式遮罩內容 -->
                  <polygon fill="white" points="276.43 450.89 431.84 450.89 431.84 717.14 541.6 717.14 541.6 450.89 697 450.89 697 362.85 276.43 362.85 276.43 450.89"/>
                  <polygon fill="white" points="1189.3 362.85 1189.3 717.13 1300.15 717.13 1300.15 579.12 1346.88 579.12 1502.29 717.13 1643.57 717.13 1444.69 540 1643.57 362.85 1502.29 362.85 1346.88 500.88 1300.15 500.88 1300.15 362.85 1189.3 362.85"/>
                  <path fill="white" d="M730.7,606.28v10.87c0,55.42,44.56,99.98,99.98,99.98h222.78c55.42,0,99.98-44.56,99.98-99.98v.03s.01-13.04.01-13.04c0-55.42-44.56-99.98-99.98-99.98l-184.75-1.09c-15.22,0-27.17-13.05-27.17-28.26v-6.52c0-15.22,11.96-27.17,27.17-27.17h143.45c7.61,0,14.13,3.26,19.56,8.69,5.44,5.43,7.61,11.95,7.61,19.56v5.43h110.85v-10.87c0-55.42-44.56-99.98-99.98-99.98h-220.61c-54.33,0-98.89,44.55-98.89,98.89v13.04c0,55.42,44.55,99.98,98.89,99.98l184.75,2.17c7.61,0,14.13,3.26,19.56,8.69,5.43,5.43,7.6,11.95,8.69,19.56v5.43c0,7.61-2.18,14.13-7.61,19.56-5.43,5.44-11.95,7.61-19.56,7.61h-154.32c-15.22,0-27.17-11.96-27.17-27.17v-5.43h-103.24Z"/>
                </g>
                <g v-else :transform="loadingMaskTransform">
                  <!-- 直式遮罩內容 -->
                  <polygon fill="white" points="122.74 905.6 217.6 905.6 217.6 1068.13 284.6 1068.13 284.6 905.6 379.46 905.6 379.46 851.86 122.74 851.86 122.74 905.6"/>
                  <polygon fill="white" points="679.97 851.86 679.97 1068.12 747.63 1068.12 747.63 983.88 776.16 983.88 871.02 1068.12 957.26 1068.12 835.86 960 957.26 851.86 871.02 851.86 776.16 936.12 747.63 936.12 747.63 851.86 679.97 851.86"/>
                  <path fill="white" d="M400.03,1000.46v6.64c0,33.83,27.2,61.03,61.03,61.03h135.99c33.83,0,61.03-27.2,61.03-61.03v.02-7.96c0-33.83-27.19-61.03-61.02-61.03l-112.77-.67c-9.29,0-16.59-7.97-16.59-17.25v-3.98c0-9.29,7.3-16.59,16.59-16.59h87.56c4.65,0,8.63,1.99,11.94,5.3,3.32,3.31,4.65,7.29,4.65,11.94v3.31h67.66v-6.64c0-33.83-27.2-61.03-61.03-61.03h-134.66c-33.16,0-60.36,27.19-60.36,60.36v7.96c0,33.83,27.19,61.03,60.36,61.03l112.77,1.32c4.65,0,8.63,1.99,11.94,5.3s4.64,7.29,5.3,11.94v3.31c0,4.65-1.33,8.63-4.65,11.94-3.31,3.32-7.29,4.65-11.94,4.65h-94.2c-9.29,0-16.59-7.3-16.59-16.59v-3.31h-63.02Z"/>
                </g>
              </mask>
            </defs>
            <!-- 由下到上填滿的色塊，適用於橫/直式 -->
            <rect
              :x="rectX"
              :y="rectY"
              :width="rectWidth"
              :height="rectHeight"
              fill="#FFF"
              mask="url(#full-mask)"
            />
          </svg>
          <div
            class="progress-svg-percent"
            :style="progressPercentStyle"
          >
            {{ percentLoaded }}%
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

export default {
  data() {
    const isPortrait = window.innerHeight / window.innerWidth > 1.05;
    const assetBase = ''; // 暫時改為本機路徑
    return {
      base: `${assetBase}/mp4/TSN/HeroIntro/web/frame_`,
      frames: 190,
      digits: 3,
      imagesLoaded: false,
      percentLoaded: 0,
      progress: 0,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      mouseIconTop: isPortrait ? 70 : 85,
      scaleStart: 0.2,
      scaleMax: 150,
      svgViewBoxWidth: 1920,
      svgViewBoxHeight: 1080,
      isPortraitMode: false,
      frameLoaded: {}, // 全部 frame 緩存
      loadGeneration: 0,
      resizeRaf: 0,
      scrollTween: null,
      portraitConfig: {
        base: `${assetBase}/mp4/TSN/HeroIntro/phone/frame_`,
        frames: 124,
        digits: 3,
        svgViewBoxWidth: 1080,
        svgViewBoxHeight: 1920,
        maskCenterOffsetX: 0,
        maskCenterOffsetY: 0
      },
      landscapeConfig: {
        base: `${assetBase}/mp4/TSN/HeroIntro/web/frame_`,
        frames: 214,
        digits: 3,
        svgViewBoxWidth: 1920,
        svgViewBoxHeight: 1080,
        maskCenterOffsetX: 0,
        maskCenterOffsetY: 0
      },



    }
  },
  computed: {
    config() {
      return this.isPortraitMode ? this.portraitConfig : this.landscapeConfig
    },
    showMask() { return true },
    fadeIn() { return this.progress > 0.01 },
    currentFrame() {
      return Math.max(1, Math.round(this.progress * this.config.frames))
    },
    currentImage() {
      const cur = this.currentFrame
      return this.frameLoaded[cur] ? this.frameLoaded[cur].src : ''
    },
    maskScale() {
      return this.scaleStart + this.progress * this.scaleMax
    },
    maskTransform() {
      const cx = (this.windowWidth / 2) + (this.config.maskCenterOffsetX || 0)
      const cy = (this.windowHeight / 2) + (this.config.maskCenterOffsetY || 0)
      return `
        translate(${cx},${cy})
        scale(${this.maskScale})
        translate(${-this.config.svgViewBoxWidth/2},${-this.config.svgViewBoxHeight/2})
      `
    },
    loadingMaskScale() {
      return 1.8
    },
    rectBaseWidth() {
      return this.config.svgViewBoxWidth;
    },
    rectBaseHeight() {
      return this.config.svgViewBoxHeight * this.percentLoaded / 100;
    },
    rectBaseX() { return 0 },
    rectBaseY() {
      return this.config.svgViewBoxHeight - this.rectBaseHeight;
    },
    rectWidth() { return this.rectBaseWidth * this.loadingMaskScale },
    rectHeight() { return this.rectBaseHeight * this.loadingMaskScale },
    rectX() {
      return (this.windowWidth - this.config.svgViewBoxWidth * this.loadingMaskScale) / 2;
    },
    rectY() {
      return (
        (this.windowHeight - this.config.svgViewBoxHeight * this.loadingMaskScale) / 2
        + this.rectBaseY * this.loadingMaskScale
      );
    },
    loadingMaskTransform() {
      const cx = (this.windowWidth / 2) + (this.config.maskCenterOffsetX || 0)
      const cy = (this.windowHeight / 2) + (this.config.maskCenterOffsetY || 0)
      return `
        translate(${cx},${cy})
        scale(${this.loadingMaskScale})
        translate(${-this.config.svgViewBoxWidth/2},${-this.config.svgViewBoxHeight/2})
      `
    },
    mouseIconVisible() {
      return this.isPortraitMode
        ? this.mouseIconTop < 93
        : this.mouseIconTop < 100;
    },
    progressPercentStyle() {
      let style = {
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10011,
        color: '#FFF',
      }
      if (this.mouseIconVisible) {
        style.top = `calc(${this.mouseIconTop}vh)`
      } else {
        style.top = 'calc(50% + 8px)'
      }
      return style
    },

  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger)
    this.checkIsPortrait()
    this.preloadAllFrames()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
    window.addEventListener('scroll', this.handleMouseIconScroll, { passive: true })


  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
    window.removeEventListener('scroll', this.handleMouseIconScroll)

    if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf)
    this.loadGeneration++
    this.destroyScrollTrigger()

  },
  methods: {

    handleMouseIconScroll() {
      let top = this.isPortraitMode
        ? 75 + window.scrollY * 0.22
        : 85 + window.scrollY * 0.2
      const maxTop = this.isPortraitMode ? 95 : 120
      if (top > maxTop) top = maxTop
      this.mouseIconTop = top
    },
    checkIsPortrait() {
      const previousMode = this.isPortraitMode
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight

      const usePhoneLayout = window.matchMedia(
        '(max-width: 899px), (orientation: portrait)'
      ).matches
      const isiPad = /iPad/.test(navigator.userAgent) || (navigator.userAgent.includes("Macintosh") && 'ontouchend' in document)

      this.isPortraitMode = usePhoneLayout || isiPad
      return previousMode !== this.isPortraitMode
    },
    handleResize() {
      if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf)

      this.resizeRaf = requestAnimationFrame(() => {
        this.resizeRaf = 0
        const modeChanged = this.checkIsPortrait()

        if (modeChanged) {
          this.preloadAllFrames()
        } else {
          ScrollTrigger.refresh()
        }
      })
    },
    destroyScrollTrigger() {
      if (!this.scrollTween) return

      if (this.scrollTween.scrollTrigger) {
        this.scrollTween.scrollTrigger.kill()
      }
      this.scrollTween.kill()
      this.scrollTween = null
    },
    setupScrollTrigger() {
      this.destroyScrollTrigger()

      const el = this.$refs.maskSection
      const duration = this.isPortraitMode
        ? window.innerHeight * 2
        : window.innerHeight * 1
      this.scrollTween = gsap.to(this, {
        progress: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top top',
          end: `+=${duration}`,
          scrub: 0.3,
          pin: true,
        }
      })
    },
    preloadAllFrames() {
      const generation = ++this.loadGeneration
      this.destroyScrollTrigger()
      this.imagesLoaded = false
      this.percentLoaded = 0
      this.progress = 0
      this.frameLoaded = {}

      let loaded = 0
      for (let i = 1; i <= this.config.frames; i++) {
        const n = String(i).padStart(this.digits, '0')
        const img = new window.Image()
        img.src = `${this.config.base}${n}.jpg`
        img.onload = () => {
          if (generation !== this.loadGeneration) return

          this.$set
            ? this.$set(this.frameLoaded, i, img)
            : (this.frameLoaded[i] = img)
          loaded++
          this.percentLoaded = Math.round((loaded / this.config.frames) * 100)
          if (loaded === this.config.frames) {
            this.imagesLoaded = true
            this.progress = 0
            this.$nextTick(() => {
              this.forceSafariRepaint()
              this.setupScrollTrigger()
            })
          }
        }
      }
    },
    forceSafariRepaint() {
      const el = this.$el.querySelector('.full-bg')
      if (el) {
        el.style.transform = 'scale(1.0001)'
        void el.offsetHeight
        el.style.display = ''
      }
    },
  }
}
</script>


<style scoped>
.svg-mask-scroll-wrapper {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  position: relative;
}
.svg-mask-container {
  width: 100vw;
  height: 100vh;
  position: relative;
}
.full-bg {
  opacity: 0;
  transition: opacity 0.8s cubic-bezier(.47,0,.53,1);
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: absolute;
  top: 0; left: 0;
  z-index: 1;
  pointer-events: none;
}
.full-bg.fade-in {
  opacity: 1;
}
.svg-viewport {
  width: 100vw;
  height: 100vh;
  display: block;
  z-index: 3;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
}

/* loading 遮罩（全覆蓋，獨立於主內容） */
.progress-mask {
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}

.scroll-mouse-icon {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: 36px;
  height: auto;
  z-index: 10010;
  opacity: 0.88;
  pointer-events: none;
  animation: bounce-scroll-mouse 1.6s infinite;
  transition: top 0.5s cubic-bezier(.47,0,.53,1);
}
.progress-svg-mask-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.progress-svg-mask {
  width: 400px;
  height: 100px;
  display: block;
  margin: 0 auto;
}
.progress-svg-percent {
  color: #FFF;
  font-size: 1.7em;
  letter-spacing: 1px;
  font-weight: 600;
  text-shadow: 0 2px 8px #0008;
}


@media (max-width: 480px) {
  .progress-svg-mask { width: 86vw; height: 22vw; }
}
@keyframes bounce-scroll-mouse {
  0%, 100% { transform: translateX(-50%) translateY(0);}
  50% { transform: translateX(-50%) translateY(8px);}
}
.full-bg,
.svg-viewport,
.svg-mask-container {
  will-change: transform, opacity;
  transform: translateZ(0);
}
.hero-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  font-family: 'PingFang TC', 'Open Sans', 'Noto Sans TC', 'Heiti TC', sans-serif;
  font-size: clamp(1rem, 2vw, 2rem);
  text-align: center;
  line-height: 1.5;
  z-index: 10;
  max-width: 90vw;
  letter-spacing: 0.05em;
  padding: 0 0.1rem;
}
.line-1 {
  display: block;
  color: #111;
  font-weight: 350;
}
.hero-bg-glow {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 108%;
  height: 160%;
  background: radial-gradient(ellipse at center, rgba(255,255,255,0.87) 60%, rgba(255,255,255,0.16) 100%);
  filter: blur(22px);
  z-index: -1;
  pointer-events: none;
  border-radius: 999px;
  /* 動畫可加 opacity: 0; 需要時淡入 */
}
.herophone-title {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  font-family: 'PingFang TC', 'Open Sans', 'Noto Sans TC', 'Heiti TC', sans-serif;
  font-size: clamp(1rem, 6vw, 2rem);
  text-align: center;
  line-height: 1.5;
  z-index: 10;
  max-width: 90vw;
  letter-spacing: 0.05em;
  padding: 0 0.1rem;
}

.line-1 {
  display: block;
  color: #111;
  font-weight: 350;
}

.gradient {
  background: linear-gradient(to bottom, #279EFF, #1ACAD2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 900;
  letter-spacing: 0.16em;
}
</style>
